import { create } from 'zustand'
import { AuthData } from '../types/auth'
export const useAuth = create<AuthData>(() => ({
  user: null,
  authUser: null,
  role: null,
  ref: null,
  admin: false,
  unsubscribe: null,
  captcha: null,
  accessLevel: null,
  claims: null,
  loading: true,
  roleItem: null,
  enrollingUser: null,
  recaptchaVerifier: null,
  enrolledFactors: null,
  multiFactorResolver: null,
  selectedEnrollmentFactor: null,
}))
